import { render, staticRenderFns } from "./brigade.vue?vue&type=template&id=698972dc&scoped=true"
import script from "./brigade.vue?vue&type=script&lang=js"
export * from "./brigade.vue?vue&type=script&lang=js"
import style0 from "./brigade.vue?vue&type=style&index=0&id=698972dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698972dc",
  null
  
)

export default component.exports